import { Pressable, Text, View } from 'react-native'

import type { ExerciseGoalItem } from '../types/statistics'
import { ExerciseGoalEditIcon } from '../assets/StatisticsIcons'
import {
  EXERCISE_GOAL_CARD_STYLE,
  TITLE_TEXT_STYLE,
  VALUE_TEXT_STYLE,
} from '../constants/statistics.styles'

interface ExerciseGoalCardProps extends ExerciseGoalItem {
  onEditPress: () => void
}

export function ExerciseGoalCard({
  label,
  value,
  onEditPress,
}: ExerciseGoalCardProps) {
  return (
    <Pressable onPress={onEditPress} style={EXERCISE_GOAL_CARD_STYLE}>
      <View className="flex-row items-start justify-between">
        <Text style={TITLE_TEXT_STYLE}>{label}</Text>
        <ExerciseGoalEditIcon />
      </View>
      <Text style={[VALUE_TEXT_STYLE, { marginTop: 4 }]}>{value}</Text>
    </Pressable>
  )
}
